import { Bag, Seat, Luggage } from 'pcln-icons'

const ANCILLARIES = [
  {
    Icon: Bag,
    label: 'Carry-on included',
  },
  {
    Icon: Seat,
    label: 'Seat selection included',
  },
  {
    Icon: Luggage,
    label: 'Checked baggage included',
  },
]

const HIDE = {
  md: true,
  lg: true,
  xl: true,
  xxl: true,
}

export { ANCILLARIES, HIDE }
